import axios from "axios";

export const api = axios.create({
  baseURL: "https://invoicing-app.onrender.com", // the url of our server or api
  withCredentials: true,
});
